<template lang="pug">
#cadastro-contrato-originacao
    BaseHeader(
        titulo='Cadastrar contrato de originação',
        :exibeBotao='false',
        :voltarPara='true'
    )

    .view-container.margen-bottom-pages
        main
            section
                h3.cadastro-contrato-originacao__subtitulo Inserir contrato de originação via planilha
                InserirViaPlanilha(
                    @atualizarTabelaContratosNaoEnviados='buscarContratosNaoEnviados'
                )

            section
                h3.cadastro-contrato-originacao__subtitulo Inserir contrato de originação manualmente
                InserirManualmente(
                    @contrato-inserido='buscarContratosNaoEnviados'
                )

            section
                h3.cadastro-contrato-originacao__subtitulo Listagem de contratos inseridos
                el-card(:body-style='{ padding: "0px" }', shadow='never')
                    Tabela(
                        :contratosNaoEnviados='contratosNaoEnviados',
                        :removendo='removendoContratos',
                        @contratosSelecionados='selecionarContratos',
                        :carregando='carregandoContratosNaoEnviados',
                        @ordenar='ordenarTabela'
                    )

                    .cadastro-contrato-originacao__paginador
                        b {{ qtdContratos }}
                        el-pagination(
                            small,
                            background,
                            layout='prev, pager, next',
                            :page-size='paginacao.tamanho',
                            :current-page.sync='paginacao.pagina',
                            :total='paginacao.total',
                            @current-change='atualizarPagina'
                        )

        footer
            .remover
                BaseButton(
                    v-if='removendoContratos',
                    @click.native='removendoContratos = false'
                ) Cancelar

                BaseButton(
                    v-if='!removendoContratos',
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removendoContratos = true'
                ) Remover

                BaseButton(
                    v-else,
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removerContratos'
                ) Confirmar remoção

            BaseButton(
                type='primary',
                icon='el-icon-s-promotion',
                @click.native='enviarContratos'
            ) Enviar contratos
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import InserirViaPlanilha from '@/components/BlocoInserirContratoOriginacaoViaPlanilha.vue';
import InserirManualmente from '@/components/BlocoInserirContratoOriginacaoManualmente.vue';
import Tabela from '@/components/TabelaCadastrarContratoOriginacao.vue';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'CadastroContratoOriginacao',
    components: {
        BaseHeader,
        InserirViaPlanilha,
        InserirManualmente,
        Tabela,
        BaseButton
    },

    data() {
        return {
            contratosNaoEnviados: [],
            contratosSelecionados: [],
            carregandoContratosNaoEnviados: false,
            paginacao: {
                pagina: 0,
                ordenacao: 'numero_contrato_valor,asc',
                tamanho: 20,
                total: 0
            },
            removendoContratos: false
        };
    },

    computed: {
        qtdContratos() {
            return this.paginacao.total === 1
                ? '1 contrato'
                : `${this.paginacao.total} contratos`;
        }
    },

    mounted() {
        this.buscarContratosNaoEnviados();
    },

    methods: {
        async buscarContratosNaoEnviados() {
            this.carregandoContratosNaoEnviados = true;
            try {
                const { data } =
                    await ContratoOriginacaoService.buscarContratosNaoEnviados(
                        this.paginacao
                    );
                this.contratosNaoEnviados = data.itens;
                this.paginacao.total = data.paginacao.total;
            } catch (error) {
                this.$notify.error({
                    message:
                        'Erro na requisição de buscar contratos não enviados.'
                });
            }
            this.carregandoContratosNaoEnviados = false;
        },

        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina;
            this.buscarContratosNaoEnviados();
        },

        ordenarTabela(ordenacao) {
            this.paginacao.ordenacao = ordenacao;
            this.buscarContratosNaoEnviados();
        },

        selecionarContratos(contratos) {
            this.contratosSelecionados = contratos;
        },

        async removerContratos() {
            if (this.contratosSelecionados.length === 0) {
                this.$notify.warning(
                    'Não há contratos selecionados para remoção.'
                );
            } else {
                for (const contrato of this.contratosSelecionados) {
                    try {
                        await ContratoOriginacaoService.removerContrato(
                            contrato
                        );
                    } catch (error) {
                        this.$notify.error({
                            message: 'Erro na requisição de remover contrato.'
                        });
                    }
                }

                this.$notify.success(
                    this.contratosSelecionados.length === 1
                        ? 'Contrato removido.'
                        : 'Contratos removidos.'
                );

                this.contratosSelecionados = [];
                this.buscarContratosNaoEnviados();
            }
        },

        async enviarContratos() {
            try {
                await ContratoOriginacaoService.enviarContratos();
                this.buscarContratosNaoEnviados();
                this.$notify.success({
                    message: 'Contrados de originação enviados com sucesso!'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro na requisição de enviar contratos.'
                });
            }
        }
    }
};
</script>

<style lang="scss">
#cadastro-contrato-originacao {
    main {
        margin: 16px 0;

        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .el-card {
        border-radius: 10px;
    }

    footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .cadastro-contrato-originacao__paginador {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 4px 16px;

        b {
            color: var(--primary);
            font-size: 12px;
        }
    }

    .cadastro-contrato-originacao__subtitulo {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
    }
}
</style>
